import { RadioOptionInput } from '@framework/form';
import clx from 'classnames';
import React from 'react';
import { RichTextAdvancedRender } from '../../../../../../inputs/rich-text-advanced/render/RichTextAdvancedRender';
import { IWidgetComponentOptionProps } from '../../../../IWidgetType';
import { ParagraphSizeText } from '../../../common/style/ParagraphSizeText';
import { OptionLabel } from '../../common/option-list/style/OptionLabel';
import { getWidgetProps } from '../../common/util/getWidgetProps';
import { ISingleSelectWidget } from '../ISingleSelectWidget';

export interface ISingleSelectOptionProps
  extends IWidgetComponentOptionProps<ISingleSelectWidget> {
  groupName: string;
}

export function SingleSelectOption(props: ISingleSelectOptionProps) {
  const { option, hideLabel } = props;

  const widgetOptions = getWidgetProps(props);

  if (!option) return;

  return (
    <RadioOptionInput
      readOnly={widgetOptions.readonly}
      className={clx({ 'hide-label': hideLabel })}
      name={props.groupName}
      optionValue={option.value}
      // Permette al campo di essere deselezionato
      allowUnselect
      disabled={option?.disabled}
    >
      <OptionLabel hideLabel={hideLabel}>
        <ParagraphSizeText>
          <RichTextAdvancedRender hasCustomFont inline text={option.label} />
        </ParagraphSizeText>
      </OptionLabel>
    </RadioOptionInput>
  );
}
